import {_, classNames, Fragment, Fuse, Highlighter, observer, pluralize, Popover2, React, styled, useEffect, useLayoutEffect} from '@api'
import {IFilterGroupItem} from '@api/graphql'
import {Button, Menu, MenuDivider, MenuItem, Switch} from '@blueprintjs/core'
import {Tooltip} from '@material-ui/core'
import {SeasonalFilterItemDefinition, SeasonalFilterItemGroupState, useVipLocalStore, utils, VipLocalStore} from '@modules'
import {FILTER_UNASSIGNED_ID} from '@modules/catalog'
import {FilterGroupStore} from '@modules/catalog/internal/filters/components/internal'
import {icons, SeasonSelectorFieldConfig, StoresInstance} from '@stores'
import {IC8SeasonSelectorData, ICategory1C8, ICategory2C8, ISeasonC8} from '@stores/c8/C8ServicesStore'
import {authStore} from '@utils'
import {PrimaryIconButton, SearchField2} from 'centric-ui-components'
import {action, autorun, computed, observable, reaction, runInAction, toJS, trace} from 'mobx'
import {expr} from 'mobx-utils'
import {ComputedValue} from 'mobx/lib/core/computedvalue'
import {ChangeEvent} from 'react'
import * as css from './SeasonSelectorFilterDropdown.css'


export const Appear = styled.div<{ visible?: boolean }>`
  display: flex;
  opacity: ${p => p.visible ? 1 : 0};
  pointer-events: ${p => p.visible ? 'default' : 'none'};
  transition: opacity 1s ease;
  content: ${p => p.visible.toString()};
`

export class SeasonSelectorFilterDropdownStore extends VipLocalStore {
  // get filterGroupName() { return `SeasonSelectorFilterDropdownStore!${this.field.field}`}
  constructor(stores: StoresInstance, public field: SeasonSelectorFieldConfig) {
    super(stores)
    this.filterGroupStore = new FilterGroupStore<{ entries?: Array<SeasonalFilterItemGroupState> }, SeasonalFilterItemDefinition>(
      this.filter,
      field.field,
      this.loadFromEs
    )

    const {catalog, catalog: {settings}} = stores
    if (!settings.seasonSelectors[field.field]) {
      settings.seasonSelectors[field.field] = {showZeroValues: true}
    }

    catalog.seasonSelectors[field.field] = this
    const {filterGroupStore: {group, catalogField}} = this
    group.def = {field: catalogField?.field, ...(catalogField?.def ?? catalogField ?? {}), name: catalogField?.field}
  }

  @computed get settings() { return this.catalog.settings.seasonSelectors[this.field.field]}

  get filter() { return this.stores.filter}

  registerEffects = () => {
    const toDispose = [
      // autorun(() => {
      //   console.log(toJS(this.filterGroupStore?.group?.selected))
      // }),
      autorun(async () => {
        const {esSearchClause, filterGroupStore: {refetch}, catalog, catalog: {isShowingAssortment, refetchId}} = this
        /*[catalogItemFilter, loadingCounts, stores.nav.queryParams.workspace, c8ItemIds]),*/
        // console.log(loadingCounts)
        if (catalog.hasLoadedConfig && esSearchClause) {
          await refetch()
        }
      }, {name: `Fetch counts for ${this.stores.storeId} ${this.field?.field}`}),
      autorun(() => {
        // Update the selected array if not available in the seasons dropdown
        const {visibleByIdField, filterGroupStore} = this
        if (!filterGroupStore?.initialLoad) {
          runInAction(() => {
            const {filterGroupStore: {group: {selected}}} = this
            Array.from(selected.keys()).map(v => {
              if (_.get(visibleByIdField[v], 'name') && visibleByIdField[v]?.displayOption == false) {
                selected.delete(v)
              }
            })
          })
        }
      })
    ]

    return () => toDispose.forEach(d => d())
  }

  @computed get offlineItemsBySeasonName() {
    const {catalog: {filteredOfflineItems}} = this, {field: {field}} = this

    return _.groupBy(filteredOfflineItems, o => {
      const k = _.get(o, `${field}.name`)
      return _.isEmpty(k) ? FILTER_UNASSIGNED_ID : k
    })
  }

  @computed get seasonSelectorFields(): Array<string> {
    const {catalog} = this
    return catalog.seasonSelectorFields.map(s => s.field)
  }

  @observable.ref filterGroupStore: FilterGroupStore<{ entries?: Array<SeasonalFilterItemGroupState> }, SeasonalFilterItemDefinition>


  /// !!!! Why are there two custom sort implementations??
  //  Done by Ashish 2b0a76e03bdbcda6166676c9157f2213956930b4
  // /
  /**
   * Mutates entries.buckets
   * @param buckets
   */
  // private _customSortBuckets = (entries: { buckets: Array<{ key?, length?: number }> }) => {
  //   // console.log(`customSortBuckets`, entries)
  //   const {catalog: {_fieldByName}, field: {field}} = this,
  //     {sort} = (_fieldByName[`${field}.name`] ?? {}),
  //     sortSequence = sort?.custom?._key?.order
  //
  //   if (entries?.buckets) {
  //     if (sortSequence) {
  //       entries.buckets = _.sortBy(entries.buckets, bucket => sortSequence.indexOf(bucket?.key) >= 0 ? sortSequence.indexOf(bucket?.key) : bucket.length + 1)
  //     }
  //     else {
  //       // Sort a-z
  //       entries.buckets = _.sortBy(entries.buckets, bucket => bucket.key)
  //     }
  //   }
  // }

  sortBuckets = (buckets) => {
    const {field: {field}, catalog: {_fieldByName}, stores} = this,
      {sort} = (_fieldByName[`${field}.name`] ?? _fieldByName[field] ?? {})
    const sortSequence = _.isFunction(sort?._func) ? sort?._func({data: buckets, stores}) : sort?.custom?._key?.order

    // console.log(`sortEntries`, entries, sortSequence)
    if (sortSequence) {
      const sortedBuckets = _.sortBy(buckets, bucket => sortSequence.indexOf(bucket?.name) >= 0 ? sortSequence.indexOf(bucket?.name) : bucket.length + 1)
      if (sortedBuckets && sortedBuckets.length)
        return sortedBuckets
    } else {
      //return _.reverse(_.sortBy(entries, ['name', 'count']))
      return _.sortBy(buckets, ['name'])
    }
  }

  ///  this.getUpdatedSearchClauseAsPerC8(_.cloneDeep(catalogItemFilterFor(({ignore: {[field]: true}}))))

  @computed get fieldName() {
    const {field} = this
    return field?.hierarchyField ?? field?.field
  }

  @computed get c8ItemIds() {
    const {fieldName, c8: {services: {c8ForCurrentWorkspace}}, filterGroupStore: {group: {selected}}} = this

    // return isBreadcrumbSourceC8 ? services.c8ForCurrentWorkspace[field].map(c => c.name) : []
    if (_.has(c8ForCurrentWorkspace, `${fieldName}ToShow`)) {
      return _.uniq((c8ForCurrentWorkspace[`${fieldName}ToShow`] ?? []).filter(v => selected.size == 0 || selected.has(v.name)).map(v => v.id).flat())
    }

    return []
  }

  get c8Dict() : Record<string, IC8SeasonSelectorData>{
    const {fieldName, c8: {services: {instance}}} = this
    return instance[`${fieldName}ById`]
  }

  get c8NameDict(): Record<string, Array<IC8SeasonSelectorData>> {
    const {fieldName, c8: {services: {instance}}} = this
    return instance[`${fieldName}NameDict`]
  }

  @computed get selectedc8ItemIds() {
    const {c8ItemIds, filterGroupStore: {initialLoad, group: {selected, groupedByValue}}} = this
    if (initialLoad) return []

    return _.uniq(selected.size ? Array.from(selected.keys()).map(k => selected.get(k)?.id ?? groupedByValue[k]?.id).flat() : /*this.c8ItemIds*/ []).filter(_.identity)
  }

  @computed get c8ItemIdsSearchClause() {
    const {field: {field}, selectedc8ItemIds} = this
    // We can't currently omit the list of all collection versions we expect to be able to see as previous CVs could be imported in our database but no longer exist in the CVs C8 tells us about
    //console.log({selectedc8ItemIds})
    return !this.catalog.isBreadcrumbSourceC8 || !selectedc8ItemIds.length ? null //|| group.selected.size === 0 || group.selected.size === _.size(group.groupedByValue) // None or all selected
                                     : ({
        terms: {
          [`${field}.exId`]: selectedc8ItemIds
        }
      })
  }

  @computed get catalogItemFilter() {
    const {catalog, fieldName, catalog: {seasonSelectorFields}} = this,
      fieldsToOurRight = seasonSelectorFields.slice(seasonSelectorFields.findIndex(f => f.field === fieldName || f.hierarchyField === fieldName) + 1)

    let ignore = {
      [fieldName]: true,
      ...fieldsToOurRight.reduce((acc, v) => ({...acc, [v.hierarchyField ?? v.field]: true}), {})
    }

    return catalog.es.catalogItemFilterFor(({ignore}))
  }

  @computed get updatedSearchClauseAsPerC8() {
    const {catalogItemFilter, c8ItemIds, c8ItemIdsSearchClause} = this

    if (!_.isEmpty(c8ItemIds)) {
      return {
        query: {
          ...catalogItemFilter?.query,
          bool: {
            ...catalogItemFilter.query.bool,
            filter: [
              ...catalogItemFilter?.query?.bool?.filter,
              c8ItemIdsSearchClause ? {...c8ItemIdsSearchClause} : undefined
            ].filter(_.identity)
          }
        }
      }
    }

    return catalogItemFilter
  }

  @computed get isLoadingFromC8() {
    const {fieldName} = this,
      {catalog: {isBreadcrumbSourceC8}, c8: {services: {c8ForCurrentWorkspace}}} = this

    return isBreadcrumbSourceC8 && c8ForCurrentWorkspace?.loading[fieldName]
  }

  @computed get catalogField() {
    const {field: {field}, catalog: {_fieldByName}} = this
    return _fieldByName[field]
  }

  @computed.struct get esSearchClause() {
    const {catalog: {workspaceConfig, hasLoadedConfig}, catalogField} = this,
      {field: {field}, catalogItemFilter, isLoadingFromC8, c8ItemIds} = this,
      {def, c8} = catalogField ?? {}

    if (!workspaceConfig?.catalog || !hasLoadedConfig || isLoadingFromC8) return null

    const esField = /*idField ? `${field}.${idField}` :*/ def?.type ? field : (!_.isEmpty(c8ItemIds) || c8) ? `${field}.exId` : `${field}.name`

    return ({
      size: 0,
      ...catalogItemFilter,
      aggs: {
        entries: {
          terms: {
            field: esField,
            min_doc_count: 0,
            size: 50000
          },
          aggs: {
            node: {top_hits: {size: 1, _source: [field]}}
          }
        },
        count: {value_count: {field: esField}},
        unassigned: {missing: {field: esField}}
      }
    })
  }

  @computed get idField() {
    const {catalogField, field, c8ItemIds} = this
    return /*field.idField ?? */((catalogField?.c8 || !_.isEmpty(c8ItemIds)) ? 'exId' : 'name')
  }

  @action loadFromEs = async () => {
    const {fieldName, es, strings,idField, field: {field, filterAvailable}, sortBuckets, esSearchClause, catalog, catalog: {isBreadcrumbSourceC8}, stores: {c8: {services: {c8ForCurrentWorkspace}}}} = this

    //console.log(`loadFromEs - ${field}`)

    if (!authStore.userIsAuthenticated || !esSearchClause || (isBreadcrumbSourceC8 && !c8ForCurrentWorkspace)) return null

    try {
      const meta = `${this.stores.storeId} - SeasonSelectorFilterDropdown.${field}.loadFromEs()`
      const {aggregations} = await es.search({
        meta: meta,
        body: esSearchClause,
        index: catalog.index
      }, {log: {query: false, result: false}})

      if (!aggregations) {
        console.warn(`No results returned for ${meta}`)
        return
      }
      let c8ResultsForField = !isBreadcrumbSourceC8 ? [] : c8ForCurrentWorkspace[`${fieldName}ToShow`]?.length ? c8ForCurrentWorkspace[`${fieldName}ToShow`] : c8ForCurrentWorkspace[`${fieldName}`],
        c8Dict = c8ResultsForField ? (c8ForCurrentWorkspace[`${fieldName}ById`] ?? {}) : {}

      const {entries, unassigned: {doc_count: unassigned}, count: {value: count}} = aggregations,
        esBuckets = (entries?.buckets ?? []).map(({doc_count: count, key, node}) => {
          if (node?.hits?.hits?.length) {
            const {hits: {hits: [{_source}]}} = node,
              values = _.get(_source, field)
            if (_.isArray(values)) {
              return values.map(f => {
                const value = _.isString(f) ? f : _.get(f, idField ?? 'name')

                return value === key ? {
                    id: [key],
                    exId: _.isString(f) ? f : f.exId,
                    name: key,
                    count
                  }
                                     : undefined
              }).filter(_.identity)[0]
            } else {
              const v = _.get(_source, field),
                id = _.isString(v) ? v : _.get(v, idField),
                name = c8Dict[id]?.name ?? (_.isString(v) ? v : _.get(v, 'name'))

              return _.isString(v) ? {id: v, exId: v, name, count} : {id: _.get(v, idField), exId: v.exId, name, count}
            }
          } else {
            return {id: key, exId: key, name: c8Dict[key]?.name ?? key, count}
          }
        })

      try {
        c8ResultsForField = filterAvailable ? filterAvailable(c8ResultsForField, this.stores) : c8ResultsForField
      }
      catch (err) {
        console.error(err)
      }

      if (!isBreadcrumbSourceC8 || _.isEmpty(c8ResultsForField)) {
        // why?  mutates entries.buckets
        if (entries?.buckets) {
          entries.buckets = sortBuckets(entries.buckets)
        }

        if (unassigned) {
          esBuckets.push({
            unassigned,
            id: FILTER_UNASSIGNED_ID,
            //count: offlineItemsBySeasonName[strings.unassigned].length,
            name: strings.unassigned
          })
        }
        return {
          data: {
            entries: esBuckets
          }, count
        }
      }

      const resultById = _.keyBy(esBuckets ?? [], v => v.exId ?? v.id)

      // Instead of showing ES data, show C8 data in Hierarchy with count from ES
      const countsDict = (c8ResultsForField ?? []).filter(_.identity).reduce((acc, item) => {
        const {id} = item,
          termValue = _.get(item, /*this.field.idField ??*/ 'name'),
          name = _.get(item, 'name')

        const thisBucket = resultById[id],
          count = thisBucket?.count ?? 0

        // console.log({thisBucket, termValue, field})
        if (acc[termValue]) {
          const v = acc[termValue]
          v.count += count
          v.id.push(id)
          v.exId.push(id)
        } else {
          acc[termValue] = {...item, id: [id], exId: [id], name, count}
        }

        return acc
      }, {})

      const sortedEntries = sortBuckets(_.values(countsDict))

      if (!_.has(resultById, FILTER_UNASSIGNED_ID)) {
        sortedEntries.push({
          count: unassigned,
          id: [FILTER_UNASSIGNED_ID],
          exId: [FILTER_UNASSIGNED_ID],
          //count: offlineItemsBySeasonName[strings.unassigned].length,
          name: FILTER_UNASSIGNED_ID
        })
      }

      // console.log({esBuckets, resultById, meta, entries, sortedEntries, c8ResultsForField, countsDict})

      runInAction(() => {
        if (sortedEntries) {
          const gbv = _.keyBy(sortedEntries.filter(v => v.count >= 0), v => v.name ?? v.id?.toString() ?? 'no-id')
          this.group.groupedByValue = gbv
        }
      })

      return {data: {entries: sortedEntries}, count}
    } finally {

    }
  }

  get group() { return this.filterGroupStore.group}
  @computed get visibleByIdField() {
    const {visible} = this
    return _.keyBy(visible, v => _.get(v, 'name'))
  }

  @computed get buttonLabel() {
    const {field: {field, label}} = this
    return label ? pluralize(label) : `${_.capitalize(field)}s`
  }

  @computed get buttonText() {
    const {strings, visible, visibleByIdField, filterGroupStore: {initialLoad, group: {selected}}, field: {label}, buttonLabel} = this
    if (visible.length > 1 && (selected.size == 0 || selected.size == visible.length)) {
      return buttonLabel
    } else if (selected.size > 0) {
      return Array.from(selected.keys()).map(v => {
        if (initialLoad) {
          return buttonLabel
        } else if (v === FILTER_UNASSIGNED_ID) {
          return strings.unassigned
        } else {
          // if (idField) {
          //   return _.get(visibleByIdField[v], 'name') ?? strings.noValue
          // } else {
            return v
          // }
        }
      }).join(', ')
    } else if (visible?.length > 0) {
      return visible[0].name || buttonLabel
    } else return label
  }

  @computed get searcher(): Fuse<IFilterGroupItem> {
    const {unfiltered} = this

    return new Fuse<IFilterGroupItem>(
      unfiltered ?? [],
      {
        keys: ['name', 'label'],
        isCaseSensitive: false,
        shouldSort: false,
        includeScore: true,
        includeMatches: false,  // turn on when debugging
        threshold: .1,
        ignoreLocation: true,
        findAllMatches: false,
        useExtendedSearch: false
      })
  }

  @computed get unfiltered() {
    const {filterGroupStore: {group: {selected}, data: {entries}}, showZeroValues, c8NameDict} = this

    let r = (entries ?? [])?.filter(v => showZeroValues || v.count > 0 || selected?.has(v.id) || v.id.includes(FILTER_UNASSIGNED_ID)) ?? []

    // if ((!loading || !_.isEmpty(r))
    //     //&& (offlineItemsBySeasonName[FILTER_UNASSIGNED_ID]?.length || unassigned)
    //     && !r.some(v => v.id === FILTER_UNASSIGNED_ID)
    // ) {
    //   r = [...r, ...unassigned]
    // }

    // Add any missing values that are selected (say from other collections before we navigated to this one or c8 season data that has no values set in ES)
    if (selected?.size) {
      const missingButSelected = Array.from(selected.keys()).filter(name => !r.some(v => v.name === name || v.id === name) )
      r = [...missingButSelected.map(name => {
        if (!c8NameDict || _.isEmpty(c8NameDict[name])) {
          return ({name, id: [name], exId: [name], count: 0, displayOption: false})
        }
        else {
          const ids = c8NameDict[name].map(v => v.id)
          return ({name, id: ids, exId: ids, count: 0})
        }
      }), ...r]
    }

    return r
  }

  @computed get searchResults() {
    const { searchText, searcher, unfiltered } = this

    return searchText && searchText != '' ? searcher.search(searchText).map(v => v.item) : (unfiltered ?? [])
  }

  @computed get visible() {
    const {filterGroupStore: {group: {selected}}, showZeroValues, searchResults, unassignedCount } = this

    return searchResults?.filter(v => (v.count > 0 || selected?.has(v.id)) || (showZeroValues && !v.id?.includes(FILTER_UNASSIGNED_ID)) || (v.id?.includes(FILTER_UNASSIGNED_ID) && unassignedCount > 0)) ?? []
  }

  @computed get unassignedCount() {
    const {offlineItemsBySeasonName} = this

    return offlineItemsBySeasonName[FILTER_UNASSIGNED_ID]?.length || 0
  }

  @computed get showZeroValues() {
    return this.settings?.showZeroValues !== false
  }

  @action toggleShowZeroValues = () => {
    this.settings.showZeroValues = !this.showZeroValues
  }

  set showZeroValues(v) {
    this.settings.showZeroValues = v
  }

  @observable searchText = ''

  @action onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    this.searchText = e.target.value ?? ''
  }

  @action clearSearch = () => this.searchText = ''

  @computed get searchWords() {
    return (this.searchText ?? '').split(' ')
  }

  @computed get hasSearchText() {
    return _.isString(this.searchText) && this.searchText.length > 0
  }
}

export const SeasonSelectorFilterDropdownStoreContext = React.createContext<SeasonSelectorFilterDropdownStore>(null)
export const useSeasonSelectorFilterDropdownStore = () => {
  return React.useContext(SeasonSelectorFilterDropdownStoreContext)
}

export const CatalogSeasonSelector = observer<{ className?: string, field: SeasonSelectorFieldConfig }>(function CatalogSeasonSelector({className, field}) {
  const store = useVipLocalStore((ws) => new SeasonSelectorFilterDropdownStore(ws, field))
  useEffect(() => store.registerEffects(), [])

  return (
    <SeasonSelectorFilterDropdownStoreContext.Provider value={store}>
      <div className={classNames(className, css.seasonSelector)}
           data-type='CatalogSeasonSelector'
           data-has-selections={store.filterGroupStore?.group?.selected?.size > 0}
           data-field={field.field}>
        <SeasonSelectorFilterDropdown field={field}/>
      </div>
    </SeasonSelectorFilterDropdownStoreContext.Provider>
  )
})

export const SeasonSelectorFilterDropdown = observer<{ field?: SeasonSelectorFieldConfig }>(function SeasonSelectorFilterDropdown({field: fieldConfig, field: {field}}) {
    const {
        strings, vlp, catalog, c8, stores: {filter: {toggleFilter}},
        filterGroupStore, visible, unfiltered, buttonText, seasonSelectorFields,
        filterGroupStore: {loading, initialLoad, group: {selected}, clearFilter, data: {entries}},
        searchText, searchWords, hasSearchText, clearSearch, offlineItemsBySeasonName,
      } = useSeasonSelectorFilterDropdownStore(),
      addItemHandler = () => c8?.openTabFor(field)

    // Causes YFTS-9429
    // useEffect(() => {
    //     const {group: {selected, store: {groupName}}, filter: {setSelection}} = filterGroupStore
    //
    //     entries && selected.forEach((value, key) => {
    //       let version = _.find(visible, (v) => key == v?.name)
    //       if (!version) { //value || _.isEmpty(value)) {
    //         selected.delete(key)
    //         //setSelection(groupName, key, _.omit(version, 'count'))
    //       }
    //     })
    //
    //
    //   }, [visible, entries])

    // YFTS-4836 Unselect any collection versions which have zero count or missing in results after a change to the hierarchy
    // YFTS-6941
    useEffect(() => {
      reaction(
        () => vlp && vlp.hierarchy.selected.plans,
        () => {
          if (catalog.c8hierarchy.hasLoadedHierarchy) {
            autorun((reaction) => {
              const {data: {entries}, loading} = filterGroupStore
              runInAction(() => {
                const {group: {selected}, groupName} = filterGroupStore
                // YFTS-6013 Season filter automatically getting reset if count is zero
                if (!(loading || _.includes(seasonSelectorFields, groupName))) {
                  entries?.forEach(({id, count}) => count === 0 && selected.delete(id))
                  Array.from(selected.keys()).forEach(s => { if (!entries.some(e => e.id == s)) { selected.delete(s) }})
                  reaction.dispose()
                }
              })
            })
          }
        })
    }, [])

    // console.debug({loading, initialLoad, visible, buttonText})

    return loading && !buttonText
           ? null
           : <div className={css.root}>
             <Popover2
               position='bottom-left'
               interactionKind='hover'
               minimal
               className={css.popover}
               //disabled={!loading}
               content={
                 <div className={css.popoverContent}>
                   <SeasonSelectorFilterToolbar/>
                   <Menu className={css.bpMenu}>
                     {visible?.map(({id, exId, name, count, ...rest}, i) => {
                       // console.log({field, id, name, count, rest})
                       let tooltip = ''
                       if (utils.isCentricID(id)) {
                         const {c8: {services: {c8ForCurrentWorkspace}}} = catalog,
                           dict = c8ForCurrentWorkspace[`${field}ById`],
                           item = dict && dict[id]

                         if (item?.season) {
                           const {season, cat1, cat2} = item as { season: ISeasonC8, cat1?: ICategory1C8, cat2?: ICategory2C8 }
                           tooltip = `${season.name}${cat1 ? ` → ${cat1.name}` : ''}${cat2 ? ` → ${cat2.name}` : ''}`
                         }
                       }

                       return (
                         <Tooltip key={name ?? i} title={tooltip} placement='right'>
                           <MenuItem shouldDismissPopover={false}
                                     data-external-id={_.isArray(exId) ? exId.join(', ') : exId}
                                     data-name={name}
                                     text={<Highlighter textToHighlight={_.isEmpty(id) || name === FILTER_UNASSIGNED_ID ? strings.unassigned : (name ?? strings.unassigned)} searchWords={searchWords}/>}
                                     labelElement={`(${count + (offlineItemsBySeasonName[name]?.length || 0)})`}
                                     icon={selected?.has(name) ? 'tick' : 'blank'}
                                     onClick={() => toggleFilter({key: field, value: name?.toString(), item: {id, exId, name}})}/>
                         </Tooltip>
                       )
                     })}

                     {hasSearchText && _.isEmpty(visible) && <Fragment>
                       <MenuItem  icon='blank' text={`No Search Results for '${searchText}'`} shouldDismissPopover={false} label='Clear Search' onClick={clearSearch} />
				                {/*<MenuItem text='Clear Search' shouldDismissPopover={false} icon={icons.clear} onClick={clearSearch}/>*/}
			         </Fragment>}

                     {!hasSearchText && fieldConfig.addItem && <Fragment> <MenuDivider/> <MenuItem key={field} icon='add' text={`${strings.add} ${pluralize(fieldConfig.label, 1)}`} onClick={addItemHandler}/> </Fragment>}

                     {false && !hasSearchText && <Fragment>
				         <MenuDivider/>
				         <MenuItem disabled={_.isEmpty(visible) || selected.size === 0}
				                   icon='blank'
				                   shouldDismissPopover={false}
				                   text='Clear Selections'
				                   onClick={clearFilter}/>
			         </Fragment>}
                   </Menu>
                 </div>
               }>
               <Button className={css.button}
                       minimal
                       text={
                         <div className={css.titleAndCount}>
                             <span className={css.title}>
              {buttonText}
                             </span>
                           <span className={css.count}>
                             {initialLoad || (loading && _.isEmpty(visible))
                              ? ''
                              : selected?.size === 1
                                ? ''
                                : unfiltered?.length === 0
                                  ? ' (0)'
                                  : ` (${(selected?.size || visible?.length) || '...'}${false && unfiltered?.length ? ` / ${unfiltered?.length}` : ''})`}
                               </span>
                         </div>} rightIcon='caret-down'/>
             </Popover2>
           </div>
  }
)

export const SeasonSelectorFilterToolbar = observer(function SeasonSelectorFilterToolbar() {
  const {showZeroValues, toggleShowZeroValues, onChangeSearch, searchText, filterGroupStore: {clearFilter, group}, strings, clearSearch, buttonLabel} = useSeasonSelectorFilterDropdownStore()

  return (<Fragment>
    <div className={css.toolbar}>

      <SearchField2 className={css.search}
                    value={searchText}
                    type='text'
                    inputProps={{size: 12}}
                    active
                    placeholder={buttonLabel}
                    onSearch={onChangeSearch}
      />

      <PrimaryIconButton icon={icons.clear}
                         tooltip='Clear' onClick={clearFilter}
                         tooltipPosition='bottom'
                         disabled={group.selected.size === 0 && group.excluded.size === 0}/>

      <div className={css.right}>
        <Switch className={css.toggle}
                onChange={toggleShowZeroValues}
                checked={showZeroValues}
                label={`Show Empty?` // ${pluralize(buttonLabel)
                }/>
      </div>
    </div>
  </Fragment>)
})

/*
 <InputGroup className={css.search}
                    type='search'
                    value={searchText}
                    leftElement={<SearchSharp className={css.searchIcon}/>}
                    rightElement={<PrimaryIconButton wrapperClassName={css.clearIcon} icon={'cross'} onClick={clearSearch}/>}
                    onChange={onChangeSearch}
                    placeholder={`${strings.search}...`} />
 */


// WEBPACK FOOTER //
// ./src/modules/siteHeader/components/SeasonSelectorFilterDropdown.tsx